/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleaseenteravalidmaximumprice5Inputs */

const en_pleaseenteravalidmaximumprice5 = /** @type {(inputs: Pleaseenteravalidmaximumprice5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid maximum price`)
};

const de_pleaseenteravalidmaximumprice5 = /** @type {(inputs: Pleaseenteravalidmaximumprice5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib einen gültigen Höchstpreis ein`)
};

/**
* | output |
* | --- |
* | "Please enter a valid maximum price" |
*
* @param {Pleaseenteravalidmaximumprice5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleaseenteravalidmaximumprice5 = /** @type {((inputs?: Pleaseenteravalidmaximumprice5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleaseenteravalidmaximumprice5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleaseenteravalidmaximumprice5(inputs)
	return de_pleaseenteravalidmaximumprice5(inputs)
});
export { pleaseenteravalidmaximumprice5 as "pleaseEnterAValidMaximumPrice" }